export const mapStyle = [];



// WEBPACK FOOTER //
// ./src/pages/representatives/mapStyle.js